<script>
  import { onMount } from "svelte"
  import axios from "axios"
  import DropDown from "./sealDropdown.svelte"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import notify from "../../../../../../Script/notify"
  import Loading from "../../../../../Templates/Documents/Edit/components/loading.svelte"
  import Loader from "../../../../../../Shared/Slots/loader.svelte"
  import { getRequest } from "../../../../../../Script/apiMethods"

  export let selectedName = ""
  export let selectedId = ""
  export let selectedImg = ""

  export let sealCount = 0
  export let seals = []
  export let sealMaxCount = 0
  export let sealEndCount = 0

  /**
   * @type {Number} seal entries
   */
  let selected = {}

  /**
   * @type {boolean} loading screen shown while dropdown items loading
   */
  let loadDropdown = true

  /**
   * @type {number} starting count of the emailList
   */
  let sealStartCount = 1

  /**
   * @type {number} pageNumber
   */
  let sealpage = 1

  /**
   * @type {boolean} whether to show loading screen or not for dropdown
   */
  let showLoadingForDropDown = false

  /**
   * @type {Boolean} - seal preview boolean
   */
  let showSeal = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  let imageBlob = ""

  let imageLoader = false

  // List page api -fetch all list of templates.
  onMount(async () => {
    try {
      selected.id = selectedId
      selected.name = selectedName
      // await fetchSeals()
    } catch (error) {
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      loadDropdown = false
    }
  })

  const fetchSeals = async (page = 1, limit = 10, sort = "-1", sortBy = "date") => {
    try {
      const data = await getRequest(`/api/pdf-signing/v2/seal?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })
      //error checking while api call
      if (data.error && !data.success) {
        throw data.errorCode
      }

      // console.log(data)

      sealCount = data.count
      seals = data.seals || []
      if (sealCount == 1) selectedId = seals[0].id
      // if (selectedId) selected = seals.filter((seal) => seal.id == selectedId)[0]
      // console.log({ selected })
      sealEndCount = sealCount < 10 ? sealCount : 10
      sealMaxCount = Math.ceil(sealCount / 10)
      // console.log({ seals })
    } catch (error) {
      throw error
    }
  }

  /**
   * Fetches the final set of email templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchSealFinalList = async () => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Increment the sealpage count to retrieve the next set of templates
      sealpage = sealMaxCount

      // Fetch the list of email templates for the updated sealpage
      await fetchSeals(sealpage)

      // Calculate the updated start and end counts for template display
      sealStartCount = (sealMaxCount - 1) * 10 + 1

      sealEndCount = sealCount
    } catch (error) {
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: While fetching the list of seal on 'Move Last' button click"
      notify.danger(error, info)
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the initial set of file templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchSealInitialList = async () => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Increment the sealpage count to retrieve the next set of templates
      sealpage = 1

      // Fetch the list of seal for the updated sealpage
      await fetchSeals(sealpage)

      // Calculate the updated start and end counts for template display
      sealStartCount = 1
      // sealEndCount = 10
      sealEndCount = sealCount < 10 ? sealCount : 10
    } catch (error) {
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: While fetching the list of seal on 'Move Forward' button click"
      notify.danger(error, info)
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Function for changing the seal
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeSeal = async (e) => {
    selected = e.detail
    selectedName = selected.name
    imageBlob = ""
    if (selected.name != "none") {
      selectedId = selected.id
      selectedImg = selected.image
    } else {
      selectedId = selectedImg = ""
    }
  }

  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchSealNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      // selected = e.detail

      // Increment the sealpage count to retrieve the next set of templates
      sealpage++

      // Fetch the list of document templates for the updated sealpage
      await fetchSeals(sealpage)

      // Calculate the updated start and end counts for template display
      if (sealpage === 1) {
        sealStartCount = sealpage + 10
        if (sealMaxCount === sealpage) sealEndCount = sealCount
        else sealEndCount = 10
      } else {
        sealStartCount = sealStartCount + 10
        if (sealMaxCount === sealpage) sealEndCount = sealCount
        else sealEndCount = sealStartCount + 9
      }

      // Update the TemplatesList with the fetched document templates
      // $TemplatesList.email = emailList.templates
    } catch (error) {
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: While fetching the list of seal on 'Next' button click"
      notify.danger(error, info)
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchSealPreviousTemplates = async () => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Decrement the sealpage count to retrieve the previous set of templates
      sealpage--

      // Fetch the list of seal for the updated sealpage
      await fetchSeals(sealpage)

      // Calculate the updated start and end counts for template display
      sealStartCount = sealStartCount - 10
      sealEndCount = sealStartCount + 9
    } catch (error) {
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: While fetching the list of seal on 'Previous' button click"
      notify.danger(error, info)
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  const handleSealPreview = async () => {
    try {
      showSeal = true
      if (imageBlob) return
      imageLoader = true

      const data = await getRequest(`/seal/file/${selectedImg}`, {
        responseType: "blob",
      })

      imageBlob = URL.createObjectURL(data)
    } catch (error) {
      // console.error(error)
      showSeal = false
      closeNotification.close()
      const info = "PAGE: Docket Creation (Seal List)\nEVENT: While fetching Seal Image"
      closeNotification = notify.danger(error, info)
    } finally {
      imageLoader = false
    }
  }
</script>

<div class="flex items-center gap-2">
  {#if loadDropdown}
    <div class="flex h-[38px] w-full items-center rounded-md border border-[#a0a1a580] pl-5 text-sm text-white">
      Loading&nbsp;&nbsp; <span>
        <Loading />
      </span>
    </div>
  {:else}
    <DropDown type="Seal" upwards={true} count={sealCount} startCount={sealStartCount} endCount={sealEndCount} maxPage={sealMaxCount} page={sealpage} bind:showLoading={showLoadingForDropDown} {selected} dropdownItems={seals} on:itemSelect={changeSeal} on:moveLast={fetchSealFinalList} on:moveFirst={fetchSealInitialList} on:fetchNext={fetchSealNextTemplates} on:fetchPrevious={fetchSealPreviousTemplates} />
  {/if}
  <button disabled={!selected?.id || loadDropdown} on:click={handleSealPreview} data-tooltip="Preview" tooltip-position="top" type="button" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:text-gray-200 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500">
    <i class="fa-solid fa-eye" />
  </button>
</div>

{#if showSeal}
  {#if imageLoader}
    <Loader>
      <span class="flex">Loading Seal&nbsp;&nbsp;</span>
    </Loader>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="fixed inset-0 -top-3 z-30 flex h-full w-full cursor-pointer select-none flex-col items-center justify-center bg-[#000000cc]"
      on:click|preventDefault|stopPropagation={() => {
        showSeal = false
      }}
    >
      <img style="background: url(assets/img/grid.png);" on:click|stopPropagation src={imageBlob} class="relative flex max-h-[80vh] min-w-[300px] max-w-[390px] cursor-default rounded-md mobile:p-0 sm:max-w-[700px]" alt="" />
      <div class="mb-6 mt-3 text-lg font-semibold text-white mobile:text-xl">To close preview, click within the black area.</div>
    </div>
  {/if}
{/if}
